module.exports = __webpack_public_path__ + "static/media/susa_logo.521a264d.png";